<div [ngClass]="class">
  <div class="dot" [ngbTooltip]="tooltip"></div>
</div>
